import { i1 } from "@/i18n/i18n";

export const formatNumber = (value: number | null | undefined, decimalPlaces: number = 1) => {
    if (value == null || value === 0) return "–";
    const locale = i1.language || "en";
    return new Intl.NumberFormat(locale, {
        style: "decimal",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    }).format(value);
};

export const formatNumberDisplay = (value: number | null | undefined) => {
    if (value == null || value === 0) return "–";
    const locale = i1.language || "en";
    return `${value.toLocaleString(locale)}`;
};

export const formatYears = (value: number | null | undefined) => {
    if (value == null || value === 0) return "–";
    const locale = i1.language || "en";
    const formattedNumber = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    }).format(value);
    const yearsText = i1.t("time.years", { count: value });
    return `${formattedNumber} ${yearsText}`;
};

export const formatPercent = (value: number | null | undefined, decimalPlaces: number = 1) => {
    if (value === null || value === undefined) return "–";
    const locale = i1.language || "en";
    return new Intl.NumberFormat(locale, {
        style: "percent",
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    }).format(value / 100);
};

export const formatCurrency = (
    value: number | null | undefined,
    minimumFractionDigits: number = 0
) => {
    if (value == null || value === 0) return "–";
    const locale = i1.language || "en";
    return `${value.toLocaleString(locale, { minimumFractionDigits, maximumFractionDigits: minimumFractionDigits, style: "currency", currency: "USD", currencyDisplay: "narrowSymbol" })}`;
};
